"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProgressBar", {
  enumerable: true,
  get: function get() {
    return _ProgressBar.default;
  }
});
Object.defineProperty(exports, "ProgressCircle", {
  enumerable: true,
  get: function get() {
    return _ProgressCircle.default;
  }
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));
var _ProgressCircle = _interopRequireDefault(require("./ProgressCircle"));
var _dec, _class, _class2, _temp;

/**
---
category: components
---
**/
var Progress = (_dec = (0, _uiTestable.default)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Progress, _Component);
  function Progress() {
    (0, _classCallCheck2.default)(this, Progress);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Progress).apply(this, arguments));
  }
  (0, _createClass2.default)(Progress, [{
    key: "render",
    value: function render() {
      var variant = this.props.variant;
      var childVariant = variant === 'bar-inverse' || variant === 'circle-inverse' ? 'inverse' : 'default';
      if (variant === 'circle' || variant === 'circle-inverse') {
        return _react.default.createElement(_ProgressCircle.default, Object.assign({}, this.props, {
          variant: childVariant
        }));
      } else {
        return _react.default.createElement(_ProgressBar.default, Object.assign({}, this.props, {
          variant: childVariant
        }));
      }
    }
  }]);
  Progress.displayName = "Progress";
  return Progress;
}(_react.Component), _class2.propTypes = {
  /**
  * A label is required for accessibility
  */
  label: _propTypes.default.string.isRequired,
  /**
  * Different-sized progress bars and circles
  */
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium', 'large']),
  /**
  * Maximum value (defaults to 100)
  */
  valueMax: _propTypes.default.number,
  /**
  * Receives the progress of the event
  */
  valueNow: _propTypes.default.number,
  /**
  * A function that returns the current value formatted for screen readers
  */
  formatValueText: _propTypes.default.func,
  /**
  * A function to format the displayed value. If null the value will not display.
  */
  formatDisplayedValue: _propTypes.default.func,
  /**
  * Animate the progress meter to the current value when the component
  * has mounted
  */
  animateOnMount: _propTypes.default.bool,
  /**
  * The bar changes to your theme's success color when complete
  */
  successColor: _propTypes.default.bool,
  /**
  * Choose either a progress bar or circle. The `-inverse` variants are for
  * when you need the Progress component to appear on inverse backgrounds
  */
  variant: _propTypes.default.oneOf(['bar', 'circle', 'bar-inverse', 'circle-inverse']),
  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  elementRef: _propTypes.default.func
}, _class2.defaultProps = {
  formatValueText: function formatValueText(valueNow, valueMax) {
    return "".concat(valueNow, " / ").concat(valueMax);
  },
  size: 'medium',
  animateOnMount: false,
  valueMax: 100,
  valueNow: 0,
  variant: 'bar',
  successColor: true,
  elementRef: function elementRef(el) {},
  formatDisplayedValue: void 0,
  margin: void 0
}, _temp)) || _class);
var _default = Progress;
exports.default = _default;